import type { RailMaintenanceTranslations } from "../interfaces/railMaintenance";

export const railMaintenanceTranslations: RailMaintenanceTranslations = {
  badge: "Em manutenção",
  send_title: "{{country}}: envios em manutenção",
  send_text:
    "Esperamos tê-los ativos em breve. Se você tem um envio urgente, escreva para nós no WhatsApp e o processamos por outra via.",
  send_whatsapp_message: "Olá, tenho um envio urgente. Destino: {{country}}.",
  receive_title: "{{country}}: depósitos em manutenção",
  receive_text:
    "Esperamos tê-los ativos em breve. Se você precisa receber um pagamento com urgência, escreva para nós no WhatsApp e ajudamos você.",
  receive_whatsapp_message: "Olá, preciso receber um pagamento urgente. País: {{country}}.",
  convert_title: "{{currency}}: envios em manutenção",
  convert_text:
    "Você pode converter para {{currency}}. Para enviar esse saldo, é preciso falar com o suporte pelo WhatsApp no {{phone}}; o processo pode demorar um pouco mais que o normal.",
  convert_whatsapp_message: "Olá, preciso enviar um saldo em {{currency}}.",
  buy_title: "Compra de {{asset}} em manutenção",
  buy_text:
    "Esperamos tê-la ativa em breve. Se você precisa comprar com urgência, escreva para nós no WhatsApp e ajudamos você.",
  buy_whatsapp_message: "Olá, preciso comprar {{asset}} com urgência.",
  sell_title: "Venda de {{asset}} em manutenção",
  sell_text:
    "Esperamos tê-la ativa em breve. Se você precisa vender com urgência, escreva para nós no WhatsApp e ajudamos você.",
  sell_whatsapp_message: "Olá, preciso vender {{asset}} com urgência.",
  card_top_up_title: "Recarga com pesos em manutenção",
  card_top_up_text:
    "Esperamos tê-la ativa em breve. Você pode recarregar o cartão de outra forma ou, se for urgente, escreva para nós no WhatsApp.",
  card_top_up_whatsapp_message: "Olá, preciso recarregar meu cartão com pesos com urgência.",
  help_line: "Precisa de ajuda? Escreva para nós no {{phone}}.",
  whatsapp_cta: "Escrever no WhatsApp",
};
